import React from 'react';
import { motion } from 'framer-motion';
export function Analyzing() {
  return <section className="flex min-h-[100svh] w-full flex-col items-center justify-center bg-beige-50 px-6" data-id="element-11" data-mp="17tieexjspt83">
      <motion.div initial={{
      opacity: 0,
      scale: 0.96
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.9,
      ease: [0.22, 1, 0.36, 1]
    }} className="flex flex-col items-center" data-id="element-12" data-mp="u2x5a0k58xne">
        <motion.div className="relative h-24 w-24" animate={{
        y: [0, -10, 0]
      }} transition={{
        duration: 4,
        ease: 'easeInOut',
        repeat: Infinity
      }} data-id="element-13" data-mp="1lumdz73mk7e1">
          <span className="absolute inset-0 rounded-full border border-sage-200" data-id="element-14" data-mp="1cto96mld3vue" />
          <motion.span className="absolute inset-0 rounded-full border border-transparent border-t-sage-600" animate={{
          rotate: 360
        }} transition={{
          duration: 2.6,
          ease: 'linear',
          repeat: Infinity
        }} data-id="element-15" data-mp="1hrgd6eza78ey" />
          <motion.span className="absolute inset-4 rounded-full bg-sage-100" animate={{
          opacity: [0.4, 0.85, 0.4]
        }} transition={{
          duration: 2.6,
          ease: 'easeInOut',
          repeat: Infinity
        }} data-id="element-16" data-mp="6e45ft0ei5ni" />
        </motion.div>

        <p className="mt-12 font-serif text-2xl font-light text-warmgray-700 sm:text-3xl" data-id="element-17" data-mp="3i1rwmsd5gdzw">
          Estamos analizando tu piel...
        </p>
      </motion.div>
    </section>;
}